import React, { memo } from 'react';
import { LeafIcon, MoonIcon, HeartIcon, BrainIcon } from 'lucide-react';
const SolutionSection = () => {
  const botanicals = [{
    icon: <LeafIcon className="w-8 h-8 text-purple-600" data-id="element-241" />,
    name: 'Lavender',
    benefit: 'Calms nerves and promotes GABA release to ease you into sleep',
    color: 'bg-purple-50 border-purple-200'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-green-600" data-id="element-242" />,
    name: 'Hops',
    benefit: 'Maintains light sleep and helps you stay asleep longer',
    color: 'bg-green-50 border-green-200'
  }, {
    icon: <HeartIcon className="w-8 h-8 text-amber-600" data-id="element-243" />,
    name: 'Cedarwood',
    benefit: 'Slows heart rate and encourages deep restorative sleep',
    color: 'bg-amber-50 border-amber-200'
  }, {
    icon: <BrainIcon className="w-8 h-8 text-blue-600" data-id="element-244" />,
    name: 'Jasmine',
    benefit: 'Balances cortisol and supports REM for memory and mood',
    color: 'bg-blue-50 border-blue-200'
  }];
  return <section className="py-16 md:py-24" data-id="element-245">
      <div className="container mx-auto px-4" data-id="element-246">
        <div className="text-center mb-16" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-248">
            The NightPhase Solution
          </h2>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-249">
            Engineered specifically for high-performers, NightPhase combines
            cutting-edge transdermal technology with nature's most effective
            sleep-enhancing botanicals.
          </p>
        </div>
        <div className="flex flex-col md:flex-row mb-16" data-id="element-250">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-251">
            <h3 className="text-2xl font-bold mb-4 text-indigo-800" data-id="element-252">
              NightPhase Delivery™ Technology
            </h3>
            <p className="text-lg text-gray-700 mb-6" data-id="element-253">
              Unlike pills that flood your system all at once, our proprietary
              transdermal patch releases precisely calibrated botanical
              compounds throughout your sleep cycle—working in harmony with your
              body's natural rhythms.
            </p>
            <p className="text-lg text-gray-700" data-id="element-254">
              The result? Fall asleep naturally, stay asleep longer, and wake up
              refreshed—without the grogginess of pills or the dependency risks
              of melatonin.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-255">
            <img src="https://images.unsplash.com/photo-1560582861-45078880e48e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="NightPhase Delivery Technology" className="rounded-lg shadow-lg" data-id="element-256" />
          </div>
        </div>
        <div className="mb-16" data-id="element-257">
          <h3 className="text-2xl font-bold mb-8 text-center text-indigo-800" data-id="element-258">
            4-Plant Botanical Blend™
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-259">
            {botanicals.map((botanical, index) => <div key={index} className={`p-6 rounded-lg border-2 ${botanical.color}`} data-id="element-260">
                <div className="mb-4" data-id="element-261">{botanical.icon}</div>
                <h4 className="text-xl font-semibold mb-2" data-id="element-262">{botanical.name}</h4>
                <p className="text-gray-700" data-id="element-263">{botanical.benefit}</p>
              </div>)}
          </div>
        </div>
        <div className="bg-indigo-900 text-white p-8 rounded-lg" data-id="element-264">
          <h3 className="text-2xl font-bold mb-4" data-id="element-265">How It Works</h3>
          <p className="text-lg mb-4" data-id="element-266">
            Simply apply the NightPhase patch to your wrist 30 minutes before
            bedtime. Our advanced transdermal technology delivers a precise dose
            of our botanical blend throughout the night, working with your
            body's natural sleep cycle.
          </p>
          <p className="text-lg" data-id="element-267">
            Unlike pills or supplements that can cause morning grogginess,
            NightPhase works in harmony with your body, allowing you to wake
            naturally refreshed and ready to perform.
          </p>
        </div>
      </div>
    </section>;
};
export default SolutionSection;